const prefix = 'instance-workspaces-section';

export const i18n = {
    noWorkspacesMessage: {
        id: `${prefix}.noWorkspacesMessage`,
        defaultMessage: 'There are no workspaces for this instance.',
    },
    loadingDatasets: {
        id: `${prefix}.loadingDatasets`,
        defaultMessage: 'Loading datasets…',
    },
    noDatasets: {
        id: `${prefix}.noDatasets`,
        defaultMessage: 'No datasets in this workspace.',
    },
    datasetsTitle: {
        id: `${prefix}.datasetsTitle`,
        defaultMessage: 'Datasets',
    },
    columnName: {
        id: `${prefix}.columnName`,
        defaultMessage: 'Name',
    },
    columnDescription: {
        id: `${prefix}.columnDescription`,
        defaultMessage: 'Description',
    },
    columnStatus: {
        id: `${prefix}.columnStatus`,
        defaultMessage: 'Status',
    },
    columnUnits: {
        id: `${prefix}.columnUnits`,
        defaultMessage: 'Units',
    },
    columnCreated: {
        id: `${prefix}.columnCreated`,
        defaultMessage: 'Created',
    },
    columnUpdated: {
        id: `${prefix}.columnUpdated`,
        defaultMessage: 'Updated',
    },
    showAllDatasets: {
        id: `${prefix}.showAllDatasets`,
        defaultMessage: 'Show all {count} datasets',
    },
    showLess: {
        id: `${prefix}.showLess`,
        defaultMessage: 'Show less',
    },
    loadingMore: {
        id: `${prefix}.loadingMore`,
        defaultMessage: 'Loading more…',
    },
    usersTitle: {
        id: `${prefix}.usersTitle`,
        defaultMessage: 'Users',
    },
    loadingUsers: {
        id: `${prefix}.loadingUsers`,
        defaultMessage: 'Loading users…',
    },
    noUsers: {
        id: `${prefix}.noUsers`,
        defaultMessage: 'No users in this workspace.',
    },
    usersLoadError: {
        id: `${prefix}.usersLoadError`,
        defaultMessage: 'Failed to load workspace users.',
    },
    columnAccount: {
        id: `${prefix}.columnAccount`,
        defaultMessage: 'Account',
    },
    columnPermission: {
        id: `${prefix}.columnPermission`,
        defaultMessage: 'Permission',
    },
    roleOwner: {
        id: `${prefix}.roleOwner`,
        defaultMessage: 'Owner',
    },
    roleContributor: {
        id: `${prefix}.roleContributor`,
        defaultMessage: 'Contributor',
    },
    roleViewer: {
        id: `${prefix}.roleViewer`,
        defaultMessage: 'Viewer',
    },
    permissionUpdateFailed: {
        id: `${prefix}.permissionUpdateFailed`,
        defaultMessage: 'Failed to update permission.',
    },
    cannotChangeOwnPermission: {
        id: `${prefix}.cannotChangeOwnPermission`,
        defaultMessage: 'You cannot change your own permission.',
    },
} as const;
